import { LayoutComponent } from './layouts/layout/layout.component';
import { VexRoutes } from '@vex/interfaces/vex-route.interface';
import { AuthAdminGuard, AuthGuard } from '../shared/auth/auth.guard';

export const appRoutes: VexRoutes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/auth/login/login.component').then(
        (m) => m.LoginComponent
      )
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./pages/auth/register/register.component').then(
        (m) => m.RegisterComponent
      )
  },
  {
    path: 'admin',
    canActivate: [AuthAdminGuard],
    component: LayoutComponent,
    children: [
      {
        path: 'tables/users',
        loadComponent: () =>
          import('./pages/aio-table/users/aio-table.component').then((m) => m.AioTableComponent),
        data: {
          toolbarShadowEnabled: false
        }
      },
      {
        path: 'tables/pages',
        loadComponent: () =>
          import('./pages/aio-table/users/aio-table.component').then((m) => m.AioTableComponent),
        data: {
          toolbarShadowEnabled: false
        }
      },
      {
        path: 'tables/categories',
        loadComponent: () =>
          import('./pages/aio-table/users/aio-table.component').then((m) => m.AioTableComponent),
        data: {
          toolbarShadowEnabled: false
        }
      }
    ]
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/pages/pages.routes')
      },
      {
        path: 'categories',
        loadChildren: () => import('./pages/pages/pages.routes')
      },
      {
        path: 'post',
        loadChildren: () => import('./pages/pages/page-layouts/page-layouts.routes')
      },
    ]
  }
];
